var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useMemo } from "react";
import { AccordionSet, Accordion, Checkbox, Button, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekAutoSuggest, RecekTextField, RecekSelection, RecekSelect, } from "./inputs";
import { EXTRA_COPY_REASONS } from "../types/enforcement";
import { useTitleNameSuggestions } from "../hooks/useTitleNameSuggestions";
import { DEFAULT_VOLUME_STATUSES } from "../utils/volumeConstants";
import { VolumeStatusBadge } from "./common/VolumeStatusBadge";
import { formatPublisherLabel } from "../utils/publisherLabel";
import { AgendaStateFilter } from "./agenda/AgendaStateFilter";
export var TitleWithIsbnFilters = function (_a) {
    var filters = _a.filters, suggestScope = _a.suggestScope, publishers = _a.publishers, isPublishersLoading = _a.isPublishersLoading, selectedPublisher = _a.selectedPublisher, _b = _a.showIsbnFilter, showIsbnFilter = _b === void 0 ? true : _b, _c = _a.showExtraCopiesFilter, showExtraCopiesFilter = _c === void 0 ? true : _c, agendaStateListType = _a.agendaStateListType, _d = _a.volumeStatuses, volumeStatuses = _d === void 0 ? DEFAULT_VOLUME_STATUSES : _d, onFilterChange = _a.onFilterChange, onStatusChange = _a.onStatusChange, onApplyFilters = _a.onApplyFilters, onPublisherInput = _a.onPublisherInput, hasUnappliedChanges = _a.hasUnappliedChanges;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var _e = useTitleNameSuggestions({
        scope: suggestScope,
        type: "MONOGRAPH",
    }), suggestions = _e.suggestions, updateSuggestQuery = _e.updateSuggestQuery;
    var publisherOptions = useMemo(function () { return __spreadArray(__spreadArray([
        {
            value: "",
            label: formatMessage({ id: "ui-br-legaldeposits.filter.select.all" }),
        }
    ], (selectedPublisher &&
        selectedPublisher.id &&
        selectedPublisher.name &&
        !publishers.some(function (p) { return p.id === selectedPublisher.id; })
        ? [
            {
                value: selectedPublisher.id,
                label: formatPublisherLabel(selectedPublisher),
            },
        ]
        : []), true), publishers.map(function (p) { return ({
        value: p.id,
        label: formatPublisherLabel(p),
    }); }), true); }, [publishers, selectedPublisher, formatMessage]);
    var extraCopyReasonOptions = useMemo(function () { return __spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-legaldeposits.filter.extraCopies.anyReason",
            }),
        }
    ], EXTRA_COPY_REASONS.map(function (opt) { return ({
        value: opt.value,
        label: formatMessage({ id: opt.labelId }),
    }); }), true); }, [formatMessage]);
    var handleAgendaStateChange = useCallback(function (value) { return onFilterChange("agendaState", value); }, [onFilterChange]);
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.name",
                }), separator: false },
                React.createElement(RecekAutoSuggest, { labelId: "ui-br-legaldeposits.filter.name", showLabel: false, value: filters.name, onChange: function (value) {
                        onFilterChange("name", value);
                        updateSuggestQuery(value);
                    }, suggestions: suggestions, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.name.placeholder",
                    }) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.publisher",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-legaldeposits.filter.publisher", showLabel: false, asyncFilter: true, value: selectedPublisher ? selectedPublisher.id : "", loading: isPublishersLoading, onFilter: onPublisherInput, onChange: function (value) {
                        onFilterChange("publisherId", value);
                    }, dataOptions: publisherOptions })),
            showIsbnFilter && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.isbn",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.isbn", showLabel: false, value: filters.isbn, onChange: function (e) { return onFilterChange("isbn", e.target.value); }, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.isbn.placeholder",
                    }) }))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.days",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.days", showLabel: false, type: "text", value: filters.days, onChange: function (e) { return onFilterChange("days", e.target.value); }, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.days.placeholder",
                    }) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.provisional",
                }), separator: false },
                React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-legaldeposits.filter.provisional.onlyProvisional",
                    }), checked: filters.provisional, onChange: function (e) { return onFilterChange("provisional", e.target.checked); } })),
            showExtraCopiesFilter && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.extraCopies",
                }), separator: false },
                React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-legaldeposits.filter.extraCopies.onlyWithExtraCopies",
                    }), checked: filters.extraCopies, onChange: function (e) { return onFilterChange("extraCopies", e.target.checked); } }),
                filters.extraCopies && (React.createElement(RecekSelect, { labelId: "ui-br-legaldeposits.enforcement.extraCopy.reasonLabel", value: filters.extraCopyReason, dataOptions: extraCopyReasonOptions, onChange: function (e) {
                        return onFilterChange("extraCopyReason", e.target.value);
                    } })))),
            agendaStateListType && (React.createElement(AgendaStateFilter, { listType: agendaStateListType, value: filters.agendaState, onChange: handleAgendaStateChange })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.status",
                }), separator: false }, volumeStatuses.map(function (vs) { return (React.createElement(Checkbox, { key: vs, label: React.createElement(VolumeStatusBadge, { status: vs }), checked: filters.statuses.includes(vs), onChange: function () { return onStatusChange(vs); } })); }))),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.apply" }))));
};
